import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { MasterApiService } from 'features/master-management/api/master-api.service';
import { queryClient } from 'providers';

import { MasterQueryKeys } from './query-keys';
const { classSubClassStatus } = MasterApiService();

export const useStatusSubCategory = () => {
  const { message } = App.useApp();

  return useMutation(
    (id: string) => {
      return classSubClassStatus(id); // Pass the subscription id to the delete function
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage); // Display error message
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: MasterQueryKeys.all, // Invalidate subscription queries to refresh the data
        });
        message.success('SubCategory Status Change Successfully'); // Display success message
      },
    },
  );
};
